$(function () {

    let intervalID;
    let triggered = false;

    $(document).ready(function () {
        var timeline = $('.ze-timeline');

        if (timeline.length > 0) {
            var isDefault = isDefaultType($(timeline).find('.timeline-events'));

            if (isDefault) {
                timeline.each(function () {
                    if (isVisible($(this))) {
                        var firstEvent = $(this).find('.event').first();
                        var lastEvent = $(this).find('.event').last();

                        if (firstEvent.length > 0) {
                            expandSection(firstEvent, lastEvent.data('index'));
                        }
                    }
                });
            }
        }
    });

    // on scroll timeline visible expand first event **
    $(window).scroll(function () {
        var timeline = $('.ze-timeline');

        if (timeline.length > 0) {

            var isDefault = isDefaultType($(timeline).find('.timeline-events'));

            if (isDefault) {
                timeline.each(function () {
                    if (isVisible($(this))) {
                        var firstEvent = $(this).find('.event').first();
                        var lastEvent = $(this).find('.event').last();

                        if (firstEvent.length > 0) {
                            expandSection(firstEvent);
                            updateArrows(firstEvent, lastEvent.data('index'));
                        }
                    }
                    else {
                        var activeEvent = $(this).find('.timeline-events').find('.event.is-active')[0];

                        if (activeEvent !== undefined && activeEvent !== null) {
                            collapseSection(activeEvent);
                        }

                    }
                });
            }
            else if (!isDefault && timeline.find('.events-track').hasClass('timeline-scroll') && isVisible(timeline) && !triggered) {
                var eventsParent = timeline.find('.timeline-events');
                var eventsTrack = eventsParent.find('.events-track');
                var lastEvent = timeline.find('.event').last();
                var events = timeline.find('.event');

                intervalID = setInterval(function () {

                    // set up the click of the next arrow until it hits the end
                    var selectedEvent = timeline.find('.event.selected');
                    var nextEvent = events[(selectedEvent.data('index') + 1)];

                    if (lastEvent != selectedEvent) {

                        selectedEvent.removeClass('selected');
                        $(nextEvent).addClass('selected');

                        updateArrows(nextEvent, lastEvent.data('index'));

                        var lastIsInFrame = checkInsideBox(eventsParent, lastEvent) == 0;

                        if (!lastIsInFrame) {
                            var currentMargin = parseInt(eventsTrack.css('margin-left').replace('px', ''));
                            eventsTrack[0].style.marginLeft = `${currentMargin - 320}px`;
                        }

                        // stop autoscroll
                        if (selectedEvent == lastEvent) clearInterval(intervalID);
                    }
                    else {
                        clearInterval(intervalID);
                    }

                }, 3000);

                triggered = true;
            }
        }
    });

    // clicking on an event directly **
    $('.timeline-events').find('.event').click(function (event) {
        // get a handle on elements
        var eventsParent = $(event.target.closest('.timeline-events'));
        var lastEvent = eventsParent.find('.event').last();

        if (isDefaultType(eventsParent)) {
            collapseSection($('.timeline-events').find('.event.is-active')[0]);
            expandSection(event.currentTarget);
        }
        else {
            $('.timeline-events').find('.event.selected').removeClass('selected');
            $(event.currentTarget).addClass('selected');
        }

        updateArrows(event.currentTarget, lastEvent.data('index'));

        // current target off frame
        if (checkInsideBox(eventsParent, $(event.target).closest('.event')) != 0) {
            var eventsTrack = eventsParent.find('.events-track');
            var offset = checkInsideBox(eventsParent, $(event.target).closest('.event'));

            if (offset > 0) {
                // off frame on the right
                var currentMargin = parseInt(eventsTrack.css('margin-left').replace('px', ''));
                eventsTrack[0].style.marginLeft = `${currentMargin - 320}px`;

            } else if (offset < 0) {
                // off frame on the left
                var currentMargin = parseInt(eventsTrack.css('margin-left').replace('px', ''));
                eventsTrack[0].style.marginLeft = `${currentMargin + 320}px`;
            }
        }

        // stop autoscroll
        if (intervalID) clearInterval(intervalID);
    });

    // next button clicked **
    $('.next-container .next').click(function (event) {

        // get a handle on elements
        var eventsParent = $(event.target.closest('.timeline-events'));
        var eventsTrack = eventsParent.find('.events-track');
        var lastEvent = eventsParent.find('.event').last();
        var currentEvent = eventsParent.find('.event.is-active');
        var nextEvent = currentEvent[0].nextElementSibling;

        if (nextEvent !== 'undefined' && isDefaultType(eventsParent)) {

            collapseSection(currentEvent[0]);
            expandSection(nextEvent);
        }
        else {
            currentEvent = $(eventsParent.find('.event.selected'));
            nextEvent = currentEvent[0].nextElementSibling;

            currentEvent.removeClass('selected');
            $(nextEvent).addClass('selected');

            // stop autoscroll
            if (currentEvent == lastEvent) clearInterval(intervalID);
        }

        updateArrows(nextEvent, lastEvent.data('index'));

        var lastIsInFrame = checkInsideBox(eventsParent, lastEvent) == 0;

        if (!lastIsInFrame) {
            var currentMargin = parseInt(eventsTrack.css('margin-left').replace('px', ''));
            eventsTrack[0].style.marginLeft = `${currentMargin - 320}px`;
        }

        // stop autoscroll
        if (intervalID) clearInterval(intervalID);
    });

    // prev button clicked **
    $('.prev-container .prev').click(function (event) {

        // get a handle on elements
        var eventsParent = $(event.target.closest('.timeline-events'));
        var eventsTrack = eventsParent.find('.events-track');
        var firstEvent = eventsParent.find('.event').first();
        var lastEvent = eventsParent.find('.event').last();
        var currentEvent = eventsParent.find('.event.is-active');
        var prevEvent = currentEvent[0].previousElementSibling;

        if (prevEvent !== 'undefined' && isDefaultType(eventsParent)) {
            collapseSection(currentEvent[0]);
            expandSection(prevEvent);
        }
        else {
            currentEvent = $(eventsParent.find('.event.selected'));
            var prevEvent = currentEvent[0].previousElementSibling;

            currentEvent.removeClass('selected');
            $(prevEvent).addClass('selected');
        }

        updateArrows(prevEvent, lastEvent.data('index'));

        var firstIsInFrame = checkInsideBox(eventsParent, firstEvent) == 0;

        if (!firstIsInFrame) {
            var currentMargin = parseInt(eventsTrack.css('margin-left').replace('px', ''));
            eventsTrack[0].style.marginLeft = `${currentMargin + 320}px`;
        }

        // stop autoscroll
        if (intervalID) clearInterval(intervalID);
    });

});

function isVisible(element) {
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();
    var elementTop = element.offset().top;
    var elementBottom = elementTop + element.height();
    return ((elementBottom <= windowBottom) && (elementTop >= windowTop));
}

function isDefaultType(element) {
    var type = element.data('type');

    return type == "default";
}

function collapseSection(element) {
    if (element[0] === 'undefined' || element[0] === null) return;

    // remove active class
    $(element).removeClass('is-active');

    element.setAttribute('data-collapsed', 'true');
}

function expandSection(element) {
    if (element[0] === 'undefined' || element[0] === null) return;

    var prevSibling = $(element)[0].previousElementSibling;
    var nextSibling = $(element)[0].nextElementSibling;

    $(element).closest('.timeline-events').find('.event').removeClass('mobile-event-sibling-prev').removeClass('mobile-event-sibling-next');
    if (prevSibling !== 'undefined') $(prevSibling).addClass('mobile-event-sibling-prev');
    if (nextSibling !== 'undefined') $(nextSibling).addClass('mobile-event-sibling-next');

    // add active class
    $(element).addClass('is-active');

    $(element).data('collapsed', 'false');
}

function updateArrows(element, lastEventIndex) {

    var nextContainer = $(element).closest('.timeline-events').find('.next-container');
    var prevContainer = $(element).closest('.timeline-events').find('.prev-container');

    if ($(element).data('index') == 0) {
        prevContainer.css("display", "none");
    } else {
        prevContainer.css("display", "flex");
    }
    if ($(element).data('index') == lastEventIndex) {
        nextContainer.css("display", "none");
    } else {
        nextContainer.css("display", "flex");
    }
}

function checkInsideBox(parent, child) {
    var parentCoords = parent[0].getBoundingClientRect();
    var childCoords = child[0].getBoundingClientRect();

    if (childCoords.right > parentCoords.right) {
        return childCoords.right - parentCoords.right;
    }

    if (childCoords.left < parentCoords.left) {
        return childCoords.left - parentCoords.left;
    }

    return 0;
}